import type { CustomFlowbiteTheme } from 'flowbite-react';

export const listGroupTheme: CustomFlowbiteTheme['listGroup'] = {
  root: {
    base: 'list-none rounded-lg border border-gray-100 bg-white text-sm font-medium',
  },
  item: {
    base: 'flex items-center justify-between text-sm font-medium first:rounded-t-lg last:rounded-b-lg border-b border-gray-100',
    link: {
      base: 'flex w-full hover:bg-titan-folly-700 hover:text-white py-2 px-4 focus:outline-none focus:ring-2 focus:ring-titan-folly-300',
      active: {
        off: 'text-titan-night-900',
        on: 'bg-titan-folly-500 text-white',
      },
      href: {
        off: '',
        on: '',
      },
      icon: 'mr-2 h-4 w-4 fill-current',
    },
  },
};
